<template>
  <div
    class="h-calcnav grid grid-cols-1fr 1xl:grid-cols-settingsprofile_desktop"
  >
    <SettingsSidebar
      :last_name="GET_USER.people_surnames"
      :date="GET_USER.email_verified_at"
      :first_name="GET_USER.people_first_name"
      :total_active_courses="GET_USER.total_active_courses"
      :imagen="GET_USER.image"
    />
    <SettingsForm />
  </div>
</template>

<script>
import SettingsSidebar from "../components/SettingsSidebar.vue";
import SettingsForm from "../components/SettingsForm.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    SettingsSidebar,
    SettingsForm,
  },
  data() {
    return {
      month: "",
    };
  },
  created() {
    this.$store.dispatch("getUser/get_user");
  },
  computed: {
    ...mapGetters("getUser", ["GET_USER"]),
  },
};
</script>
